import React from 'react'
import ContestForm from './contestForm'

const AddContest = () => {
  return (
    <>
     <ContestForm action="add"/> 
    </>
  )
}

export default AddContest
